import objectPath from 'object-path';

import { client as apolloClient } from 'core/client';

export class Subscription {
  subscriptionProcessor = null;

  // @observable loading = true;
  // @observable data = null;
  // @observable error = null;

  constructor(
    appManager,
    { variables = {}, fetchPolicy = 'cache-and-network' },
  ) {
    const subscriptionOptions = {
      query: this.constructor.conf.GQL,
      // context: {},
      // errorPolicy: '',
      fetchPolicy,
      variables,
    };
    this.subscriptionObservable = apolloClient.subscribe(subscriptionOptions);

    if (appManager) appManager.disposers.push(this.disposer);
  }

  // Reusing name to keep the "feel" of core/query, but only a single "processor" is allowed at a time
  process = callback => {
    this.subscriptionProcessor = callback;
  };

  disposer = () => {
    this.CompleteSubscription();
  };

  StartSubscription = () => {
    this.subscription = this.subscriptionObservable.subscribe({
      next: nextResult => {
        const { data } = nextResult;
        if (!this.subscriptionProcessor) return;
        const { resultPath } = this.constructor.conf;
        if (resultPath && !objectPath.has(data, resultPath)) {
          console.error(
            `Trying to get resultPath '${resultPath}' on Subscription ${this.constructor.name} which does not exist on the data`,
          );
        }
        this.subscriptionProcessor(
          resultPath ? objectPath.get(data, resultPath, null) : data,
        );
      },
      error: err => {
        console.error(err);
      },
      complete: () => {},
    });
  };

  CompleteSubscription = () => {
    if (this.subscription) this.subscription.unsubscribe();
    this.subscription = null;
  };
}
